<div class="MainPopup" style="width: 500px">
  <div class="text-right" style="cursor: pointer">
    <a (click)="close('close')"><i class="fa fa-times"></i></a>
  </div>
  <fieldset class="w-90 fieldset">
    <legend>Reviewing</legend>
    <section class="d-flex">
      <div class="mt-10 mx-5 w-100">
        <kendo-textarea
          class="mt-5"
          placeholder="Add SME consultation comments"
          [(ngModel)]="smeReviewComment"
          [rows]="5"
          [cols]="100"
          resizable="both"
        ></kendo-textarea>
      </div>
    </section>
    <kendo-dialog-actions>
      <button kendoButton (click)="close('close')">Cancel</button>
      <button
        kendoButton
        class="primary-button"
        (click)="close('submit')"
      >
        Add Review
      </button>
    </kendo-dialog-actions>
  </fieldset>
</div>
